import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.scss']
})
export class CertificateComponent {
  @Input() type: string = 'name';
  @Input() data: any;

  @ViewChild('certificateContainer') certificateContainer!: ElementRef;


// downloadCertificate() {

//   const content = document.getElementById('certificateContainer');

//   if (!content) {
//     return;
//   }

//   const iframe = document.createElement('iframe');

//   iframe.style.position = 'fixed';
//   iframe.style.right = '0';
//   iframe.style.bottom = '0';
//   iframe.style.width = '0';
//   iframe.style.height = '0';
//   iframe.style.border = '0';

//   document.body.appendChild(iframe);

//   const doc = iframe.contentWindow?.document;

//   if (!doc) {
//     return;
//   }

//   // Copy all stylesheets from current page
//   const styles = Array.from(document.querySelectorAll(
//     'link[rel="stylesheet"], style'
//   ))
//     .map(el => el.outerHTML)
//     .join('');

//   doc.open();

//   doc.write(`
//     <html>
//       <head>
//         ${styles}
//         <style>
//           @page {
//             size: A4;
//             margin: 10mm;
//           }

//           body {
//             margin: 0;
//             padding: 0;
//           }
//         </style>
//       </head>
//       <body>
//         ${content.outerHTML}
//       </body>
//     </html>
//   `);

//   doc.close();

//   iframe.onload = () => {
//     iframe.contentWindow?.focus();
//     iframe.contentWindow?.print();

//     setTimeout(() => {
//       document.body.removeChild(iframe);
//     }, 1000);
//   };
// }
downloadCertificate() {
  // <div class="print-date">
  //         Date: ${printDate}
  //       </div>
  const content = document.getElementById('certificateContainer');

  if (!content) {
    return;
  }

  // const printDate = new Date().toLocaleDateString('en-GB', {
  //   day: 'numeric',
  //   month: 'long',
  //   year: 'numeric'
  // });

  const iframe = document.createElement('iframe');

  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';

  document.body.appendChild(iframe);

  const doc = iframe.contentWindow?.document;

  if (!doc) {
    return;
  }

  const styles = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style')
  )
    .map(el => el.outerHTML)
    .join('');

  doc.open();

  doc.write(`
    <html>
      <head>
        ${styles}
        <style>
          @page {
            size: A4;
            margin: 10mm;
          }

          body {
            margin: 0;
            padding: 0;
          }

          .print-date {
            text-align: right;
            font-size: 14px;
            margin: 10px 20px 20px 0;
            font-family: 'Times New Roman', serif;
          }
           
          .pageWrapper {
                position: relative; 
          }
.content-wrapper {
        position: relative;
        z-index: 1;
      }

        </style>
      </head>
      <body>

    
    <div class="print-wrapper">
      <div class="content-wrapper">
        ${content.outerHTML}
      </div>
    </div>

     

      </body>
    </html>
  `);

  doc.close();

  iframe.onload = () => {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };
}
downloadPDF() {
    const element = document.getElementById('certificate');

    // html2pdf()
    //   .from(element)
    //   .set({
    //     margin: 0,
    //     filename: `${this.type}-certificate.pdf`,
    //     html2canvas: { scale: 2 },
    //     jsPDF: { unit: 'px', format: 'a4' }
    //   })
    //   .save();
  }

  
    getOrdinal(n: number): string {

  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;

  return n + (
    s[(v - 20) % 10] ||
    s[v] ||
    s[0]
  );
}
 formatDate(dateStr: string): string {
  const [day, month, year] = dateStr.split('/').map(Number);

  const monthName = new Date(year, month - 1).toLocaleString('en-US', {
    month: 'long'
  });

  return `${this.getOrdinal(day)} day of ${monthName} ${year}`;
}
}
function html2pdf() {
  throw new Error('Function not implemented.');
}

